export const AUTH_VERIFY_EMAIL = "AUTH_VERIFY_EMAIL";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
export const AUTH_SIGN_UP_DEFAULT = "AUTH_SIGN_UP_DEFAULT";
export const AUTH_SIGN_IN_DEFAULT = "AUTH_SIGN_IN_DEFAULT";
export const AUTH_VERIFY_TOKEN = "AUTH_VERIFY_TOKEN";
export const AUTH_CHANGE_ROLE = "AUTH_CHANGE_ROLE";